import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Home from './pages/Home';
import Multiplayer from './pages/Multiplayer';
import InfoPage from './pages/InfoPage';
import LegalFooter from './components/LegalFooter';
import HowToPlay from './pages/HowToPlay';
import NotFound from './pages/NotFound';
import PageMeta from './components/PageMeta';
import Contact from './pages/Contact';
// @ts-ignore
import OriginalApp from './App.original';

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/singleplayer" element={<SinglePlayerWrapper />} />
        <Route path="/multiplayer" element={<><PageMeta title="Multiplayer | Anime Opening Quiz" description="Play Anime Opening Quiz with friends." path="/multiplayer" index={false} /><Multiplayer /></>} />
        <Route path="/how-to-play" element={<HowToPlay />} />
        <Route path="/about" element={<InfoPage page="about" />} />
        <Route path="/privacy" element={<InfoPage page="privacy" />} />
        <Route path="/terms" element={<InfoPage page="terms" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <LegalFooter />
    </>
  );
}

// Wrapper component to integrate the original App with routing
function SinglePlayerWrapper() {
  const navigate = useNavigate();
  
  // Pass navigate function to original app to handle back to menu
  return <><PageMeta title="Play | Anime Opening Quiz" description="Play Anime Opening Quiz in single-player mode." path="/singleplayer" index={false} /><OriginalApp defaultMode="singleplayer" onNavigateHome={() => navigate('/')} /></>;
}

export default App;
